import { type PagamentoWithDettaglioDTO } from '@framework/api-client/api/inquiries-compile/schemas/pagamentoWithDettaglioDTO.ts';
import { t } from '@framework/i18n/intl/i18next.ts';
import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import { type ColumnsType } from 'antd/es/table';
import { type Key } from 'react';
import styled from 'styled-components';
import { EnumCodStatoPagamento } from '../../../../burden/payments/EnumCodStatoPagamento.tsx';
import { PaymentBurdenTypeTags } from '../../../../burden/payments/PaymentBurdenTypeTags.tsx';
import { PaymentStateTag } from '../../../../burden/payments/PaymentStateTag.tsx';
import { paymentsColumnsBase } from '../../../../burden/payments/paymentsColumns.tsx';

export const PaymentsTableWrapper = styled.div`
  .payment-row-expandable {
    cursor: pointer;
  }
  .payment-row-da-pagare > td {
    background-color: #fff8e6 !important;
  }
  .payment-row-pendente > td {
    background-color: #fff8e6 !important;
  }
  .payment-row-successo > td {
    background-color: #f0fff0 !important;
  }
  .payment-row-fallimento > td {
    background-color: #fff0f0 !important;
  }
`;

export function getPaymentRowClassName(
  record: PagamentoWithDettaglioDTO,
  expandedKeys: readonly Key[],
): string {
  const isExpandable =
    record.id != null && record.oneri != null && record.oneri.length > 0;
  const expandableClass = isExpandable ? 'payment-row-expandable' : '';
  const isExpanded = record.id != null && expandedKeys.includes(record.id);

  if (!isExpanded) return expandableClass;

  switch (record.codStatoPagamento) {
    case EnumCodStatoPagamento.DA_PAGARE:
      return `payment-row-da-pagare ${expandableClass}`;
    case EnumCodStatoPagamento.PENDENTE:
      return `payment-row-pendente ${expandableClass}`;
    case EnumCodStatoPagamento.SUCCESSO:
      return `payment-row-successo ${expandableClass}`;
    case EnumCodStatoPagamento.FALLIMENTO:
      return `payment-row-fallimento ${expandableClass}`;
    default:
      return expandableClass;
  }
}

export const summaryPaymentsColumns: ColumnsType<PagamentoWithDettaglioDTO> = [
  {
    ...paymentsColumnsBase.stato,
    render: (_, record) => (
      <PaymentStateTag
        state={record.codStatoPagamento as EnumCodStatoPagamento}
        color={
          record.codStatoPagamento === EnumCodStatoPagamento.DA_PAGARE
            ? '#9E6C00'
            : undefined
        }
      />
    ),
  },
  {
    title: t('summary-payments.tipo', 'Tipo'),
    key: 'tipo',
    render: (_, record) => <PaymentBurdenTypeTags payment={record} />,
  },
  paymentsColumnsBase.valore,
  paymentsColumnsBase.codice,
  {
    title: t('summary-payments.data-creazione', 'Data creazione'),
    dataIndex: 'dataCreazione',
    key: 'dataCreazione',
    render: (_, record) => (
      <ISODate date={record.dataCreazione} format="DD/MM/YYYY, HH:mm" />
    ),
  },
  {
    title: t('summary-payments.data-pagamento', 'Data pagamento'),
    dataIndex: 'dataPagamento',
    key: 'dataPagamento',
    render: (_, record) =>
      record.dataPagamento ? (
        <ISODate date={record.dataPagamento} format="DD/MM/YYYY, HH:mm" />
      ) : (
        <span>&mdash;</span>
      ),
  },
  {
    title: t('summary-payments.oneri', 'Oneri'),
    key: 'oneriCount',
    align: 'center',
    render: (_, record) => record.oneri?.length ?? 0,
  },
];
